export const STORE_ACCESS_DETAILS = 'AUTH/STORE_ACCESS_DETAILS';
export const CLEAR_ACCESS_DETAILS = 'AUTH/CLEAR_ACCESS_DETAILS';
export const UPDATE_SESSION = 'AUTH/UPDATE_SESSION';
